/* Photo carousel of the shop-location section: arrows, dots, a "1 / 3"
   counter, swipe, and the arrow keys when it has focus. In the theme editor,
   selecting an image block shows its photo. */
if (!customElements.get('shop-location-carousel')) {
  customElements.define('shop-location-carousel', class ShopLocationCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.shop-location__track');
      this.slides = [...this.track.children];
      this.dots = [...this.querySelectorAll('[data-carousel-dot]')];
      this.count = this.querySelector('[data-carousel-count]');
      this.index = 0;

      this.querySelector('[data-carousel-prev]').addEventListener('click', () => this.go(this.index - 1));
      this.querySelector('[data-carousel-next]').addEventListener('click', () => this.go(this.index + 1));
      this.dots.forEach((dot) => dot.addEventListener('click', () => this.go(Number(dot.dataset.carouselDot))));

      this.tabIndex = 0;
      this.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') this.go(this.index - 1);
        if (event.key === 'ArrowRight') this.go(this.index + 1);
      });

      let startX = null;
      this.addEventListener('pointerdown', (event) => {
        if (!event.target.closest('button')) startX = event.clientX;
      });
      this.addEventListener('pointerup', (event) => {
        if (startX === null) return;
        const distance = event.clientX - startX;
        if (Math.abs(distance) > 40) this.go(this.index + (distance < 0 ? 1 : -1));
        startX = null;
      });

      document.addEventListener('shopify:block:select', (event) => {
        const slide = this.slides.findIndex((s) => s.dataset.blockId === event.detail.blockId);
        if (slide >= 0) this.go(slide);
      });

      this.go(0);
    }

    go(index) {
      this.index = (index + this.slides.length) % this.slides.length;
      this.track.style.transform = `translateX(${-100 * this.index}%)`;
      this.slides.forEach((slide, i) => slide.setAttribute('aria-hidden', i !== this.index));
      this.dots.forEach((dot, i) => dot.setAttribute('aria-current', i === this.index));
      this.count.textContent = `${this.index + 1} / ${this.slides.length}`;
    }
  });
}
